<template>
	<div class="modals" v-if="cdata.show" >
		<div class="modals-box" >
			<div class="modals-header">
				<h2 class="mh-title">{{cdata.title}}</h2>
				<i class="mh-close iconfont icon-duibiguanbi" @click="cdata.show=false"></i>
			</div>
			<div class="modals-content">
				<h1 class="comfirm-info"><i class="iconfont icon-jinggao"></i>{{cdata.content}}</h1>
			</div>
			<div class="modals-footer">
				<div class="mf-btns">
					<span class="btn-mf btn-cancel"  @click="cdata.show=false">取消</span>
					<span class="btn-mf btn-submit" @click="comfirm">确认</span>
					
				</div>
				
			</div>
		</div>

    </div>
</template>
<script>
	export default{
		name:'cancel',
		props:{
			option:{
				type:Object,
				default:()=>{
					return {}
				}
				
			}
		},
		data(){
			return{
				cdata:''
			}
			
		},
		watch:{
			option(val){
				
				this.cdata=val;

			}
		},
		methods:{
			comfirm(){
				this.$emit('select',this.cdata.token)
			}
		},
		mounted(){
			this.cdata=this.option;
		}

	}
</script>
<style scoped>

.modals{
	position: fixed;
	height: 100%;
	width: 100%;
	background-color: rgba(68, 68, 68, 0.38);
	left: 0;
	top: 0px;
	z-index: 9;

}
.modals-box{
    background-color: #fff;
    width: 80%;
    padding: 0 30px 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: 3px;
    padding-bottom: 40px;
}
.modals-header{
    height: 45px;
    line-height: 45px;
	border-bottom: 1px solid #f3f3f3;
	position: relative;
}
.mh-title{
	font-size: 16px;
	color:#000;
	font-weight: 400;

}
.mh-close{
	font-size: 16px;
	color:#888;
	position: absolute;
	right:0px;
	top:0px;
	cursor: pointer;
}
.mcz-title{
	font-size: 14px;
	color:#46b9fe;
	margin:20px 0;
}
.mcz-item{
	display: -webkit-flex;   
 	display: flex;
 	justify-content: space-between;
 	margin-bottom: 20px;

}
.mcz-item>label{
	display: inline-block;
    width: 11%;
    margin-bottom: 0px;
    font-weight: 400;
    line-height: 40px;
    font-size: 14px;
    color:#333;

}
.mcz-select>div>.btn>span{
	position: absolute;
    right: 12px;
    margin-left: 0px;
}
.mcz-select>div>.btn{
	width: 100%;
    padding: 9px 12px;
    text-align: left;

}
.mcz-select>div{
	width: 100%;
}
.mcz-select{
	width: 89%;
	
}
.mc-zone>.mcz-item:last-child{
	margin-bottom: 0px;
}

.btn-mf{
	display: inline-block;
	height: 34px;
	line-height: 34px;
	text-align: center;
	border-radius: 3px;
	cursor: pointer;
	width: 50%;


}
.mf-btns{
	display: -webkit-flex; 
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
}
.modals-footer{
	position: absolute;
	width: 100%;
	left: 0px;
    bottom: 0px;
}

.comfirm-info{
	margin:30px 14px;
	font-size: 18px;

}
.comfirm-info>i{
	font-size: 24px;
	margin-right: 12px;
	color:#ffb600;
}


</style>


// WEBPACK FOOTER //
// src/components/common/cmpnt/cancel.vue